import 'ui-theme/components/issue-item/js/issue-item';
UX.issueItem.seeMoreText = 'see more';
UX.issueItem.seeLessText = 'see less';
UX.issueItem.truncateOptions.seeMoreIcon = 'icon-section_arrow_d';
UX.issueItem.truncateOptions.seeLessIcon = 'icon-section_arrow_u';
UX.issueItem.truncateOptions.seeMoreIconMobile = 'icon-arrow_r';
UX.issueItem.setCaptions = function () {};
